import { ChakraFlex, CircularProgress, Text } from '@equip.health/ui';

import { MAI_CHAT_HISTORY_LOADING } from './maiChat.constants';

const MaiChatHistoryLoading = () => (
  <ChakraFlex
    data-testid="mai-chat-history-loading"
    role="status"
    aria-label={MAI_CHAT_HISTORY_LOADING}
    alignItems="center"
    justifyContent="center"
    gap="8px"
    padding="8px 0"
  >
    <CircularProgress
      id="mai-chat-history-loading__progress"
      isIndeterminate
      size="16px"
    />
    <Text color="neutral.secondary" variant="caption">
      {MAI_CHAT_HISTORY_LOADING}
    </Text>
  </ChakraFlex>
);

export default MaiChatHistoryLoading;
